import React, { useState } from 'react';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';

const styles = `
.vale-page {
  min-height: 100vh;
  background-color: white;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1rem;
}

.vale-content {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 4rem;
  align-items: start;
}

.gift-card-preview {
  position: sticky;
  top: 2rem;
}

.gift-card {
  background: linear-gradient(135deg, #e0f2f2 0%, #f9fafb 100%);
  border-radius: 1rem;
  padding: 3rem 2rem;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #d1d5db;
}

.gift-card-title {
  font-size: 2rem;
  color: #4A8080;
  margin-bottom: 0.5rem;
  font-weight: 300;
}

.gift-card-value {
  font-size: 3rem;
  color: #5A9C9C;
  font-weight: 600;
  margin: 2rem 0;
}

.gift-card-message {
  font-size: 0.95rem;
  color: #6b7280;
  font-style: italic;
  min-height: 60px;
  padding: 1rem;
  background-color: white;
  border-radius: 0.5rem;
}

.vale-form-section {
  background-color: white;
}

.page-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  margin-bottom: 0.5rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.page-price {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 2rem;
  font-weight: 500;
}

.page-description {
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1.0625rem;
}

.vale-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.form-label {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-input,
.form-textarea {
  padding: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #5A9C9C;
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.value-options {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}

.value-btn {
  padding: 0.875rem;
  border: 2px solid #d1d5db;
  background-color: white;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  color: #374151;
}

.value-btn:hover {
  border-color: #5A9C9C;
  color: #5A9C9C;
}

.value-btn.selected {
  border-color: #5A9C9C;
  background-color: #f0f9f9;
  color: #5A9C9C;
}

.custom-value-input {
  grid-column: span 2;
}

.radio-group {
  display: flex;
  gap: 1.5rem;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  accent-color: #5A9C9C;
  cursor: pointer;
}

.radio-option label {
  cursor: pointer;
  color: #374151;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 200px;
}

.qty-btn {
  width: 40px;
  height: 40px;
  border: 1px solid #d1d5db;
  background-color: white;
  border-radius: 0.375rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  transition: all 0.3s;
  color: #374151;
}

.qty-btn:hover {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.qty-value {
  flex: 1;
  text-align: center;
  font-size: 1.125rem;
  font-weight: 600;
  color: #374151;
}

.submit-btn {
  width: 100%;
  padding: 1.125rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 1rem;
}

.submit-btn:hover {
  background-color: #3A6666;
}

@media (max-width: 1024px) {
  .vale-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .gift-card-preview {
    position: relative;
    top: 0;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 2rem;
  }

  .value-options {
    grid-template-columns: repeat(3, 1fr);
  }

  .custom-value-input {
    grid-column: span 3;
  }

  .gift-card-value {
    font-size: 2.5rem;
  }
}

@media (max-width: 480px) {
  .value-options {
    grid-template-columns: repeat(2, 1fr);
  }

  .custom-value-input {
    grid-column: span 2;
  }

  .radio-group {
    flex-direction: column;
    gap: 1rem;
  }
}
`;

export default function ValePresentePage() {
  const [selectedValue, setSelectedValue] = useState('5');
  const [customValue, setCustomValue] = useState('');
  const [recipient, setRecipient] = useState('outra');
  const [quantity, setQuantity] = useState(1);
  const [formData, setFormData] = useState({
    emailDestinatario: '',
    nomeDestinatario: '',
    dataEntrega: '',
    mensagem: ''
  });
  const { alertProps, showSuccess } = useCustomAlert();

  const presetValues = ['5', '10', '15', '16', '20', '25', '50', '100', '150', '200'];

  const handleValueSelect = (value) => {
    setSelectedValue(value);
    setCustomValue('');
  };

  const handleCustomValueChange = (e) => {
    const value = e.target.value;
    setCustomValue(value);
    if (value) {
      setSelectedValue('custom');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const finalValue = selectedValue === 'custom' ? customValue : selectedValue;
    
    console.log('Vale-presente:', {
      valor: finalValue,
      quantidade: quantity,
      destinatario: recipient,
      ...formData
    });
    
    showSuccess('Vale-presente adicionado ao carrinho com sucesso!');
  };

  const getCurrentValue = () => {
    if (selectedValue === 'custom' && customValue) {
      return customValue;
    }
    return selectedValue || '0';
  };

  return (
    <>
      <style>{styles}</style>
      <div className="vale-page">
        <div className="container">
          <div className="vale-content">
            <div className="gift-card-preview">
              <div className="gift-card">
                <h3 className="gift-card-title">Gift Card</h3>
                <div className="gift-card-value">{getCurrentValue()} €</div>
                {formData.mensagem && (
                  <div className="gift-card-message">
                    "{formData.mensagem}"
                  </div>
                )}
              </div>
            </div>

      <div className="vale-form-section">
        <h1 className="page-title">Barco de Papel Vale-presente digital</h1>
        <p className="page-price">5 €</p>
        <p className="page-description">
          Escolha um valor e escreva uma mensagem personalizada para que o vale-presente 
          tenha a sua cara.
        </p>

        <form className="vale-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Valor</label>
            <div className="value-options">
              {presetValues.map((value) => (
                <button
                  key={value}
                  type="button"
                  className={`value-btn ${selectedValue === value ? 'selected' : ''}`}
                  onClick={() => handleValueSelect(value)}
                >
                  {value} €
                </button>
              ))}
              <input
                type="number"
                className="form-input custom-value-input"
                placeholder="Outro valor"
                value={customValue}
                onChange={handleCustomValueChange}
                min="1"
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Quantidade</label>
            <div className="quantity-controls">
              <button
                type="button"
                className="qty-btn"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                −
              </button>
              <span className="qty-value">{quantity}</span>
              <button
                type="button"
                className="qty-btn"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Para quem é o vale-presente?</label>
            <div className="radio-group">
              <div className="radio-option">
                <input
                  type="radio"
                  id="outra-pessoa"
                  name="recipient"
                  value="outra"
                  checked={recipient === 'outra'}
                  onChange={(e) => setRecipient(e.target.value)}
                />
                <label htmlFor="outra-pessoa">Para outra pessoa</label>
              </div>
              <div className="radio-option">
                <input
                  type="radio"
                  id="para-mim"
                  name="recipient"
                  value="mim"
                  checked={recipient === 'mim'}
                  onChange={(e) => setRecipient(e.target.value)}
                />
                <label htmlFor="para-mim">Para mim</label>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="emailDestinatario">
              Email do destinatário *
            </label>
            <input
              type="email"
              id="emailDestinatario"
              name="emailDestinatario"
              className="form-input"
              value={formData.emailDestinatario}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="nomeDestinatario">
              Nome do destinatário
            </label>
            <input
              type="text"
              id="nomeDestinatario"
              name="nomeDestinatario"
              className="form-input"
              value={formData.nomeDestinatario}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="dataEntrega">
              Data de entrega
            </label>
            <input
              type="date"
              id="dataEntrega"
              name="dataEntrega"
              className="form-input"
              value={formData.dataEntrega}
              onChange={handleChange}
              placeholder="Agora"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="mensagem">
              Mensagem
            </label>
            <textarea
              id="mensagem"
              name="mensagem"
              className="form-textarea"
              value={formData.mensagem}
              onChange={handleChange}
              placeholder="Escreva uma mensagem personalizada..."
            />
          </div>

          <button type="submit" className="submit-btn">
            Comprar
          </button>
        </form>
      </div>
      </div>
      </div>
      <CustomAlert {...alertProps} />
      </div>
    </>
  );
}